import { Users, ChevronRight, MessageCircle } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface ProfileCommunityCardProps {
  newConversationsCount?: number;
}

export const ProfileCommunityCard = ({ newConversationsCount = 2 }: ProfileCommunityCardProps) => {
  const navigate = useNavigate();
  
  return (
    <div 
      className="bg-wellness-peach-light/40 rounded-2xl p-5 border border-wellness-peach/20 flex items-center justify-between cursor-pointer hover:bg-wellness-peach-light/60 transition-all active:scale-[0.98]" 
      onClick={() => navigate('/app/comunidad')}
    >
      <div className="flex items-center gap-4">
        <div className="relative">
          <div className="w-12 h-12 bg-wellness-peach rounded-2xl flex items-center justify-center text-white shadow-sm">
            <Users className="h-6 w-6" />
          </div>
          {newConversationsCount > 0 && (
            <div className="absolute -top-1 -right-1 w-4 h-4 bg-primary text-primary-foreground text-[9px] font-bold flex items-center justify-center rounded-full border-2 border-background">
              {newConversationsCount}
            </div>
          )}
        </div>
        <div>
          <h3 className="font-heading font-bold text-foreground text-base">Comunidad</h3>
          {newConversationsCount > 0 ? (
            <div className="flex items-center gap-1 mt-0.5 text-xs font-medium text-wellness-peach flex-wrap">
              <MessageCircle className="h-3 w-3" />
              <span>{newConversationsCount} nuevas interacciones</span>
            </div>
          ) : (
            <p className="text-xs text-muted-foreground mt-0.5">Conéctate con otros participantes</p>
          )}
        </div>
      </div>
      <div className="bg-background/50 p-2 rounded-full">
        <ChevronRight className="h-4 w-4 text-wellness-peach" />
      </div>
    </div>
  );
};
